import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    RacecardSecondaryHeaderLoader,
    RacecardRowLoader,
    FirstLineRaceInfo,
    SecondLineRaceInfo,
    RacecardSummaryHeaderLoader,
    RaceCardSummaryLoaderWrapper,
    EventRowsLoaderWrapper,
} from 'src/domains/layouts/shared/loaders';
import { RaceRow } from './RaceRow';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

export const RaceSummaryLoader = observer('RaceSummaryLoader', () => {
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const { sportsbookVariant } = configState.componentVariants;

    const eventRows = [];
    for (let i = 0; i < 15; i++) {
        eventRows.push(<RaceRow key={i} />);
    }
    return (
        <>
            <RacecardRowLoader>
                <FirstLineRaceInfo variant={sportsbookVariant} />
                <SecondLineRaceInfo variant={sportsbookVariant} />
                <SecondLineRaceInfo
                    additional={true}
                    variant={sportsbookVariant}
                />
            </RacecardRowLoader>
            <RaceCardSummaryLoaderWrapper variant={sportsbookVariant}>
                <RacecardSecondaryHeaderLoader variant={sportsbookVariant} />
                <RacecardSummaryHeaderLoader variant={sportsbookVariant} />
                <EventRowsLoaderWrapper variant={sportsbookVariant}>{eventRows}</EventRowsLoaderWrapper>
            </RaceCardSummaryLoaderWrapper>
        </>
    );
});
